export { default as default } from './NotFound';
